import React from 'react'

export const TwitterIcon = () => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.9572 20.7645L12.9617 9.10816L12.9754 9.11907L20.1844 0.764526H17.7754L11.9026 7.56453L7.23899 0.764526H0.920809L8.38535 11.6473L8.38445 11.6463L0.511719 20.7645H2.92081L9.4499 13.1991L14.639 20.7645H20.9572ZM6.28445 2.58271L17.5026 18.9463H15.5935L4.36626 2.58271H6.28445Z" fill="#323232" />
    </svg>
  )
}
